import * as _ from 'lodash'
import React from 'react';
import { getCollection, ModelCollection } from 'Scripts/store';
import * as actions from '../actions';
import componentServices from '../componentServices';
import * as fileActions from '../fileActions';import { PhotoModal } from './sharedComponents';

class JobPhotosContainer extends React.PureComponent<any,any> {
	constructor (props) {
		super(props);

		this.handleFileChange = this.handleFileChange.bind(this);
	}

	handleFileChange (e) {
		e.preventDefault();
		this.props.uploadFiles(e.target.files);
	}

	onPhotoClick (image) {
		actions.pushModal({
			component: <PhotoModal file={ image } />,
			props: { classNames: ['photo']}
		});
	}

	render () {
		const { files } = this.props;

		const photoListings = _.map(_.sortBy(files, 'name'), file => {
			return (
				<a key={ file.url } className="button photo" onClick={ this.onPhotoClick.bind(this, file) }><img src={file.url} /><span /></a>
			);
		});

		return (
			<section>
				<header>
					<span>PHOTOS</span>
					<div className="actions">
						<div className="button iconLabel upload">
							<span>Upload a Photo</span>
							<input type="file" onChange={this.handleFileChange} multiple={ true } />
						</div>
					</div>
				</header>
				<div className="inner">
					<div className="photos">
						{ photoListings }
					</div>
				</div>
			</section>
		);
	}
}

export default class JobPhotosEdit extends React.PureComponent<any,any> {
	constructor (props) {
		super(props);

		this.uploadFiles = this.uploadFiles.bind(this);
	}

	componentDidMount () {
		fileActions.fetchFilesForJob({ job: this.props.job });
	}

	uploadFiles (files) {
		_.forEach(files, f => {
			fileActions.enqueueUpload({ rootKey: this.props.job.key, rootType: 'job', file: f });
		});
	}

	updateModel (updater, options) {
		this.props.updateModel(model => {
			updater(model);
		}, options);
	}

	render () {
		const { store } = componentServices;
		const { job } = this.props;

		const jobFiles = getCollection({ store, collection: ModelCollection.files }).filter(f => {
			return (f.group === 'photos' && f.rootKey === job.key);
		});

		return (
			<div>
				<JobPhotosContainer updateModel={this.updateModel} title='PHOTOS' files={jobFiles.toJS()} uploadFiles={this.uploadFiles} />
			</div>
		);
	}
}